/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

//import auth from '@/auth/authService'

import firebase from 'firebase/app';
import 'firebase/auth';

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            //component: () => import('./views/Dashboard.vue'),
            meta: {
              auth: true
            },
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              {
                path: '/management/myadmin',
                name: 'agent',
                component: () => import('./views/management/employee-list/Employee.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/banner',
                name: 'banner',
                component: () => import('./views/management/banner/Banner.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/banner2',
                name: 'banner2',
                component: () => import('./views/management/banner/Banner2.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/banner3',
                name: 'banner3',
                component: () => import('./views/management/banner/Banner3.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/banner4',
                name: 'banner4',
                component: () => import('./views/management/banner/Banner4.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/banner5',
                name: 'banner5',
                component: () => import('./views/management/banner/Banner5.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/banner6',
                name: 'banner6',
                component: () => import('./views/management/banner/Banner6.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/background',
                name: 'background',
                component: () => import('./views/management/banner/Background.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/background2',
                name: 'background2',
                component: () => import('./views/management/banner/Background2.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/background3',
                name: 'background3',
                component: () => import('./views/management/banner/Background3.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/background4',
                name: 'background4',
                component: () => import('./views/management/banner/Background4.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/background5',
                name: 'background5',
                component: () => import('./views/management/banner/Background5.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/background6',
                name: 'background6',
                component: () => import('./views/management/banner/Background6.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/',
                name: 'udomchai',
                component: () => import('./views/management/user-list/Udomchai.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/starextra',
                name: 'starextra',
                component: () => import('./views/management/user-list/Starextra.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laohd',
                name: 'laohd',
                component: () => import('./views/management/user-list/LaoHD.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laoasean',
                name: 'laoasean',
                component: () => import('./views/management/user-list/LaosAsean.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laosnight',
                name: 'laosnight',
                component: () => import('./views/management/user-list/LaoNight.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laoextra',
                name: 'laoextra',
                component: () => import('./views/management/user-list/LaoExtra.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laogrowextra',
                name: 'laogrowextra',
                component: () => import('./views/management/user-list/LaoGlowExtra.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/luangnamtha',
                name: 'luangnamtha',
                component: () => import('./views/management/user-list/Luangnamtha.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/chaiyaburi',
                name: 'chaiyaburi',
                component: () => import('./views/management/user-list/Chaiyaburi.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/redcross',
                name: 'redcross',
                component: () => import('./views/management/user-list/Redcross.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laopatuchai',
                name: 'laopatuchai',
                component: () => import('./views/management/user-list/LaoPatuchai.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laosantipap',
                name: 'laosantipap',
                component: () => import('./views/management/user-list/LaoSantipap.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/laopachachon',
                name: 'laopachachon',
                component: () => import('./views/management/user-list/Laopachachon.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/chaisomboon',
                name: 'chaisomboon',
                component: () => import('./views/management/user-list/Chaisomboon.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/lao12zodiac',
                name: 'lao12zodiac',
                component: () => import('./views/management/user-list/Lao12zodiac.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/lao',
                name: 'lao',
                component: () => import('./views/management/user-list/Lao.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoitravel',
                name: 'hanoitravel',
                component: () => import('./views/management/user-list/Hanoitravel.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoistarextra',
                name: 'hanoistarextra',
                component: () => import('./views/management/user-list/HanoiStarExtra.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/btc',
                name: 'btc',
                component: () => import('./views/management/user-list/Btc.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/palm',
                name: 'palm',
                component: () => import('./views/management/user-list/Palm.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoi',
                name: 'hanoi',
                component: () => import('./views/management/user-list/Hanoi.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoi5g',
                name: 'hanoi5g',
                component: () => import('./views/management/user-list/Hanoi5G.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoivip',
                name: 'hanoivip',
                component: () => import('./views/management/user-list/HanoiVip.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoiextra',
                name: 'hanoiextra',
                component: () => import('./views/management/user-list/HanoiExtra.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoiasean',
                name: 'hanoiasean',
                component: () => import('./views/management/user-list/HanoiAsean.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoisamakkhi',
                name: 'hanoisamakkhi',
                component: () => import('./views/management/user-list/HanoiSamakkhi.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoinight',
                name: 'hanoinight',
                component: () => import('./views/management/user-list/HanoiNight.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/vientiane',
                name: 'vientiane',
                component: () => import('./views/management/user-list/Vientiane.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/luangprabang',
                name: 'luangprabang',
                component: () => import('./views/management/user-list/Luangprabang.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/udomchai',
                name: 'udomchai',
                component: () => import('./views/management/user-list/Udomchai.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/nikkei',
                name: 'Nikkei',
                component: () => import('./views/management/user-list/Nikkei.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/chinese',
                name: 'Szse',
                component: () => import('./views/management/user-list/Chinese.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hangseng',
                name: 'Hangseng',
                component: () => import('./views/management/user-list/Hangseng.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/ktop',
                name: 'Ktop',
                component: () => import('./views/management/user-list/Ktop.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/tokyo',
                name: 'Tokyo',
                component: () => import('./views/management/user-list/Tokyo.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/ftse',
                name: 'Ftse',
                component: () => import('./views/management/user-list/Ftse.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/dax',
                name: 'Dax',
                component: () => import('./views/management/user-list/Dax.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/moexbluechip',
                name: 'Moexbluechip',
                component: () => import('./views/management/user-list/Moexbluechip.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/dowjones',
                name: 'Dowjones',
                component: () => import('./views/management/user-list/Dowjones.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/dowjones-specialone',
                name: 'Dowjones-Specialone',
                component: () => import('./views/management/user-list/Dowjones-Specialone.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/dowjones-extraspecial',
                name: 'Dowjones-ExtraSpecial',
                component: () => import('./views/management/user-list/Dowjones-ExtraSpecial.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/dowjones-starspecial',
                name: 'Dowjones-StarSpecial',
                component: () => import('./views/management/user-list/Dowjones-StarSpecial.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/lao-chow',
                name: 'lao-chow',
                component: () => import('./views/management/user-list/LaoChow.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/hanoi-special',
                name: 'hanoi-special',
                component: () => import('./views/management/user-list/HanoiSpecial.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/malay-dragon',
                name: 'malay-dragon',
                component: () => import('./views/management/user-list/MalayDragon.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/malay-special',
                name: 'malay-special',
                component: () => import('./views/management/user-list/MalaySpecial.vue'),
                meta: {
                  auth: true
                }
              },
              /*
              {
                path: '/management/role',
                name: 'role',
                component: () => import('./views/management/role-list/Role.vue'),
                meta: {
                  auth: true
                }
              },
              {
                path: '/management/role/form/:roleId',
                name: 'role-edit-form',
                component: () => import('./views/management/role-edit/RoleEdit.vue'),
                meta: {
                  auth: true,
                  parent: 'app-role-list',
                }
              },*/
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
        // =============================================================================
        // PAGES
        // =============================================================================
              {
                path: '/login',
                name: 'page-login',
                component: () => import('@/views/pages/Login.vue')
              },
              {
                path: '/pages/error-404',
                name: 'page-error-404',
                component: () => import('@/views/pages/Error404.vue')
              },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
      if (!firebase.auth().currentUser) {
          next({
              path: '/login'
          })
      } else {
          next()
      }
  } else {
      next()
  }
})
export default router
